export default "__VITE_ASSET__DwpoDMas__"